export var ExactSearchRequest = function (_a, callback) {
    var baseUri = _a.baseUri, searchTerm = _a.searchTerm, customerNumber = _a.customerNumber, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, _d = _a.limit, limit = _d === void 0 ? 10 : _d;
    // let protocol: string = window.location.protocol;
    // let host: string = window.location.host;
    // console.log(baseUri);
    var api = "".concat(baseUri, "/api/products/search?searchTerm=").concat(searchTerm, "&page=").concat(page, "&limit=").concat(limit, "&exactSearch=true&customerNumber=").concat(customerNumber);
    var response = fetch(api, {
        method: "GET",
        credentials: 'include',
        mode: "cors"
    });
    response.then(function (data) {
        data.text().then(function (json) {
            callback(json);
        });
    });
};
export var FuzzySearchRequest = function (_a, callback, CategorieFilter, AttributeFilter) {
    var baseUri = _a.baseUri, searchTerm = _a.searchTerm, _b = _a.page, page = _b === void 0 ? 1 : _b, _c = _a.offset, offset = _c === void 0 ? 0 : _c, _d = _a.limit, limit = _d === void 0 ? 10 : _d;
    var protocol = window.location.protocol;
    var host = window.location.host;
    var api = "".concat(baseUri, "/en/search/product");
    var response = fetch(api, {
        method: "POST",
        credentials: 'include',
        mode: "cors",
        body: JSON.stringify({
            searchTerm: searchTerm,
            page: page,
            limit: limit,
            offset: offset,
            exactSearch: false,
            categorieFilter: CategorieFilter,
            attributeFilter: AttributeFilter
        })
    });
    response.then(function (r) {
        callback(r);
    });
};
export default { ExactSearchRequest: ExactSearchRequest, FuzzySearchRequest: FuzzySearchRequest };
